import { useMemo } from 'react';
import { FilterByNumber } from '../../../../types/types';
import { IonCol, IonGrid, IonRange, IonRow, IonText } from '@ionic/react';
import { RangeValue } from '@ionic/core';
import Message from '../../../Message/Message';
import { FilterData } from '../../../FilterForm/FilterForm';
export type FilterNumberRangeValue = string[];

interface IFilterNumberRangeProps {
  onChange: (filterData: FilterData) => void;
  filter: FilterByNumber;
  filterData?: FilterData;
}

export default function FilterNumberRange({
  onChange,
  filter,
  filterData,
}: IFilterNumberRangeProps) {
  let from, to;
  if (filterData?.values) {
    from = filterData.values[0] || null;
    to = filterData.values[1] || null;
  }
  const { minValue, maxValue } = filter;

  const rangeValue: RangeValue = useMemo(
    () => ({
      lower: from || minValue || 0,
      upper: to || maxValue || 10e6,
    }),
    [from, to, minValue, maxValue]
  );

  const handleChange = ({ detail: { value } }: CustomEvent) => {
    onChange({
      id: filter.id,
      values: [value.lower.toString(), value.upper.toString()],
    });
  };

  return (
    <div className="ion-padding">
      <IonGrid>
        <IonRow>
          <IonCol>
            <IonText color={'medium'}>
              <Message id={'minimum'} />
            </IonText>
          </IonCol>
          <IonCol className={'ion-text-right'}>
            <IonText color={'medium'}>
              <Message id={'maximum'} />
            </IonText>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonText color={'primary'}>{rangeValue.lower}</IonText>
          </IonCol>
          <IonCol className={'ion-text-right'}>
            <IonText color={'primary'}>{rangeValue.upper}</IonText>
          </IonCol>
        </IonRow>
      </IonGrid>
      <IonRange
        dualKnobs
        debounce={200}
        value={rangeValue}
        max={maxValue}
        min={minValue}
        onIonChange={handleChange}
      />
    </div>
  );
}
